export default __webpack_public_path__ + "static/media/shape2.c85acc4a.png";